'use strict';

var React = require('react');

var SvgStoreImportIcon = function SvgStoreImportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.75a.75.75 0 0 0-1.5 0v2.69l-.47-.47a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l1.75-1.75a.75.75 0 0 0-1.06-1.06l-.47.47v-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10.776v4.474a1.75 1.75 0 0 1-1.75 1.75h-7.5a1.75 1.75 0 0 1-1.75-1.75v-4.474c-1.317-.583-2.003-2.198-1.295-3.612l.079-.159a1.75 1.75 0 0 1 .189-.298l2.378-3.027c.338-.43.853-.68 1.399-.68a.75.75 0 1 1 0 1.5.279.279 0 0 0-.22.107l-2.378 3.027a.25.25 0 0 0-.027.042l-.079.159a1.15 1.15 0 0 0 2.059 1.029l.474-.95a.747.747 0 0 1 1.006-.335.748.748 0 0 1 .394.496l.074.295a1.491 1.491 0 0 0 2.894 0l.074-.295a.748.748 0 0 1 .981-.531.744.744 0 0 1 .419.37l.475.95a1.15 1.15 0 1 0 2.058-1.03l-.08-.158a.255.255 0 0 0-.026-.042l-2.379-3.027a.279.279 0 0 0-.219-.107.75.75 0 0 1 0-1.5c.546 0 1.061.25 1.399.68l2.378 3.027c.073.093.136.193.19.298l.079.159c.707 1.414.02 3.03-1.296 3.612Zm-1.5.19v4.284a.25.25 0 0 1-.25.25h-.75v-2.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2.5h-3.75a.25.25 0 0 1-.25-.25v-4.284a2.651 2.651 0 0 0 1.705-1.038 2.99 2.99 0 0 0 4.59 0c.41.554 1.023.927 1.705 1.038Z"
  }));
};
SvgStoreImportIcon.displayName = "StoreImportIcon";

exports.SvgStoreImportIcon = SvgStoreImportIcon;
